/**
 * Ovládání přehledu pro centrálu (#3732).
 *
 * Období je v roletě: kvartál rovnou přejde na svou adresu, "Vlastní" jen odkryje
 * pole Od/Do. Vlastní období se odešle samo, jakmile uživatel vybere konec –
 * po výběru začátku se rovnou otevře kalendář pro konec.
 */
const attachPeriod = (filtr) => {
    const select = filtr.querySelector('[data-ref="periodSelect"]')
    const panel = filtr.querySelector('.reports-custom-period')

    if (!select || !panel) {
        return
    }

    select.addEventListener('change', () => {
        if (select.value === 'custom') {
            panel.classList.add('is-open')
            panel.querySelector('[data-ref="customFrom"]')?.focus()
            return
        }

        window.location.href = select.value
    })

    const od = panel.querySelector('[data-ref="customFrom"]')
    const do_ = panel.querySelector('[data-ref="customTo"]')
    const $ = window.jQuery

    if (!od || !do_ || !$) {
        return
    }

    const puvodni = () => `${od.value}|${do_.value}`
    const aplikovane = puvodni()

    // Datepicker je jQuery plugin a události vysílá přes jQuery, proto $.on.
    $(od).on('hide', () => {
        if (od.value && puvodni() !== aplikovane) {
            do_.focus()
        }
    })

    $(do_).on('hide', () => {
        if (od.value && do_.value && puvodni() !== aplikovane) {
            panel.requestSubmit()
        }
    })
}

/**
 * Výběr center v režimu Multi (#3732) – každé zaškrtnutí se po krátké prodlevě
 * odešle samo, takže jde naklikat víc center najednou bez několika načtení.
 */
const attachCenterSelect = () => {
    const form = document.querySelector('[data-ref="centerSelect"]')

    if (!form) {
        return
    }

    let casovac = null

    form.querySelectorAll('input[type="checkbox"]').forEach((chip) => {
        chip.addEventListener('change', () => {
            clearTimeout(casovac)
            casovac = setTimeout(() => form.requestSubmit(), 600)
        })
    })
}

document.querySelectorAll('.reports-header-filter').forEach(attachPeriod)
attachCenterSelect()
